export default class EventContentTagEditor {
    static extractTag(joomlaEditorName) {
        if (!window.parent || !window.parent.Joomla || !window.parent.Joomla.editors || !window.parent.Joomla.editors.instances[joomlaEditorName]) {
            return null;
        }

        const editor = window.parent.Joomla.editors.instances[joomlaEditorName];
        let selection = editor.getSelection();
        let value = editor.getValue();

        // 0. Fallback for empty selection (just a cursor position)
        let originalSelectionEmpty = (!selection || selection.trim().length === 0);
        if (originalSelectionEmpty) {
            // TinyMCE fallback
            if (window.parent.tinyMCE && window.parent.tinyMCE.get(joomlaEditorName)) {
                let tmce = window.parent.tinyMCE.get(joomlaEditorName);
                if (tmce.selection) {
                    let rng = tmce.selection.getRng();
                    if (rng && rng.startContainer) {
                        let text = "";
                        let offset = 0;
                        if (rng.startContainer.nodeType === 3) {
                            text = rng.startContainer.nodeValue;
                            offset = rng.startOffset;
                        }
                        
                        if (text) {
                            let regex = /\{eventgallery[^}]*\}/g;
                            let match;
                            while ((match = regex.exec(text)) !== null) {
                                let start = match.index;
                                let end = start + match[0].length;
                                if (offset >= start && offset <= end) {
                                    selection = match[0];
                                    break;
                                }
                            }
                        }
                    }
                }
            }
            // CodeMirror fallback
            else if (editor.editor && typeof editor.editor.getCursor === 'function') {
                let cm = editor.editor;
                let cursor = cm.getCursor();
                if (cursor) {
                    let lineText = cm.getLine(cursor.line);
                    let regex = /\{eventgallery[^}]*\}/g;
                    let match;
                    while ((match = regex.exec(lineText)) !== null) {
                        let start = match.index;
                        let end = start + match[0].length;
                        if (cursor.ch >= start && cursor.ch <= end) {
                            selection = match[0];
                            break;
                        }
                    }
                }
            }
        }

        // 1. Is selection already a full tag?
        if (selection && selection.trim().startsWith('{eventgallery') && selection.trim().endsWith('}')) {
            if (!originalSelectionEmpty) {
                return { tag: selection.trim(), method: 'selection' };
            }
            // If originalSelectionEmpty is true, we invented this selection via fallback.
            // We MUST let it fall through to step 2 so it resolves via method='expand', 
            // because `replaceSelection` won't work on an empty selector!
        }

        // 2. Can we expand the selection to a full tag?
        if (selection && selection.length > 0) {
            // Find occurrences of this selection in the full text
            const occurrences = value.split(selection).length - 1;
            if (occurrences === 1) { // Only try if unique to be safe
                const idx = value.indexOf(selection);
                const tagStart = value.lastIndexOf('{eventgallery', idx);
                const tagEnd = value.indexOf('}', idx);

                if (tagStart !== -1 && tagEnd !== -1 && tagStart <= idx && tagEnd >= idx) {
                    // Make sure we are actually inside the tag and it didn't already close before our selection
                    const textBeforeCursor = value.substring(tagStart, idx);
                    if (!textBeforeCursor.includes('}')) {
                        const fullTag = value.substring(tagStart, tagEnd + 1);
                        return { tag: fullTag, method: 'expand', originalSelection: selection, startIndex: tagStart, endIndex: tagEnd + 1 };
                    }
                }
            }
        }

        return null;
    }

    static replaceTag(joomlaEditorName, extractedInfo, newTag) {
        if (!window.parent || !window.parent.Joomla || !window.parent.Joomla.editors || !window.parent.Joomla.editors.instances[joomlaEditorName]) {
            return false;
        }

        const editor = window.parent.Joomla.editors.instances[joomlaEditorName];

        if (!extractedInfo || extractedInfo.method === 'selection') {
            editor.replaceSelection(newTag);
            return true;
        }

        if (extractedInfo.method === 'expand' && extractedInfo.startIndex !== undefined && extractedInfo.endIndex !== undefined) {
            const oldValue = editor.getValue();
            // Sanity check to make sure the tag there is still what we think it is (close enough)
            if (oldValue.substring(extractedInfo.startIndex, extractedInfo.startIndex + 13) === '{eventgallery') {
                const newValue = oldValue.substring(0, extractedInfo.startIndex) + newTag + oldValue.substring(extractedInfo.endIndex);
                editor.setValue(newValue);
                return true;
            } else {
                 // Fallback if the text unexpectedly shifted, just insert at selection
                 editor.replaceSelection(newTag);
                 return true;
            }
        }

        editor.replaceSelection(newTag);
        return true;
    }
}

window.Eventgallery = window.Eventgallery || {};
window.Eventgallery.EventContentTagEditor = EventContentTagEditor;